import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\ApplyIndexingItemController::__invoke
* @see app/Http/Controllers/Item/ApplyIndexingItemController.php
* @route '/api/item/apply-indexing'
*/
const ApplyIndexingItemController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ApplyIndexingItemController.url(options),
    method: 'post',
})

ApplyIndexingItemController.definition = {
    methods: ["post"],
    url: '/api/item/apply-indexing',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Item\ApplyIndexingItemController::__invoke
* @see app/Http/Controllers/Item/ApplyIndexingItemController.php
* @route '/api/item/apply-indexing'
*/
ApplyIndexingItemController.url = (options?: RouteQueryOptions) => {
    return ApplyIndexingItemController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\ApplyIndexingItemController::__invoke
* @see app/Http/Controllers/Item/ApplyIndexingItemController.php
* @route '/api/item/apply-indexing'
*/
ApplyIndexingItemController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ApplyIndexingItemController.url(options),
    method: 'post',
})

export default ApplyIndexingItemController